import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { SponsorType } from '../sponsor-type.enum';
import { SponsorService } from '../sponsor.service';

@Component({
    selector: 'app-sponsor-edit',
    templateUrl: './sponsor-edit.component.html',
    styleUrls: ['./sponsor-edit.component.scss'],
    standalone: false
})
export class SponsorEditComponent extends BaseComponent implements OnInit, AfterViewInit {
  
  public canEditSponsor: boolean = true;
  public sponsors: SponsorType; 
  private id: string;

  public form = new FormGroup({
    name: new FormControl('',{
      validators: Validators.required
    }),
    company: new FormControl(''),
    contactEmail: new FormControl('',{
    validators: Validators.required
    }),
    requestReceipt: new FormControl(false),
    amount: new FormControl(),
    type: new FormControl(SponsorType.Donation),
    notes: new FormControl(''),
    outingIterationId: new FormControl(),
    createdBy: new FormControl(),
  });

  constructor(public sessionService: SessionService,
    private globalDataService: GlobalDataService,
    private route: ActivatedRoute,
    private router: Router,
    stringHelpers: StringHelpers,
    private sponsorService: SponsorService) {
    super(sessionService, stringHelpers);
   }

   ngOnInit(): void {
    if(this.isGlobalOutingSet()){
      this.selectedIteration = this.getGlobalOutingIteration();
      this.canEditSponsor = this.checkIterationDate();
      this.id = this.route.snapshot.paramMap.get('id');
      this.getSponsor();
    }
  }

  ngAfterViewInit(): void {
    this.globalDataService.iterationSelectionEvent.subscribe(result => {
      this.selectedIteration = result;
      this.canEditSponsor = this.checkIterationDate();
      this.getSponsor();
    });
  }

  getSponsor(){
    this.sponsorService.getById(this.id).subscribe(result => {
      this.form.patchValue(result);
    });
  }

  keys(): Array<string>{
    var keys = Object.keys(SponsorType);
    var test = keys.slice(keys.length / 2, keys.length)
    return test;
  }

  parseEnumValue(value: string){
    switch(value.toLowerCase()){
      case 'holesponsor': 
        return 'Hole Sponsor';
      case 'cartsponsor':
        return 'Cart Sponsor';
      default:
        return value;
    }
  }

  parseEnumKey(value: string){
    switch(value.toLowerCase()){
      case 'holesponsor': 
        return 1;
      case 'cartsponsor':
        return 2;
      case 'donation':
        return 3;
      case 'team':
        return 4;
      case 'other':
        return 5;
      default:
        return value;
    }
  }

  onSubmit({ value, valid }) {
    if (valid) {
      this.isLoading = true;
      value.createdBy = this.sessionService.getUserId();
      value.outingIterationId = this.selectedIteration.id;
      this.sponsorService.update(this.id, value).subscribe(() => {
        this.isLoading = false;
        this.form.reset();
        this.form.clearAsyncValidators();
        this.form.clearValidators();
        this.isLoading = false;
        this.router.navigate([`/outing-management/administration/sponsor/details/${this.id}`]);
      }, (err: any) => {
        this.isLoading = false;
        this.setError(err, this.form);
      });
    }
  }

}
